import dayjs from "dayjs";

// DRAFT -> COMPLETED -> QUOTED; DRAFT/COMPLETED -> CANCELLED. QUOTED and
// CANCELLED are read-only. COMPLETED is the office's work queue, hence amber.
export const SURVEY_STATUS_CLASS = {
  DRAFT: "badge-linesecondary",
  COMPLETED: "badge-linewarning",
  QUOTED: "badge-linesuccess",
  CANCELLED: "badge-linedanger",
};

export const SURVEY_STATUS_LABEL = {
  DRAFT: "Draft",
  COMPLETED: "Completed",
  QUOTED: "Quoted",
  CANCELLED: "Cancelled",
};

// List tabs - Completed first (the office's queue) and the default.
export const SURVEY_STATUS_TABS = [
  { value: "COMPLETED", label: "Completed" },
  { value: "DRAFT", label: "Draft" },
  { value: "QUOTED", label: "Quoted" },
  { value: "CANCELLED", label: "Cancelled" },
  { value: "", label: "All" },
];

export const ATTACHMENT_KINDS = [
  { value: "PHOTO", label: "Photos" },
  { value: "DRAWING", label: "Drawings" },
  { value: "DOCUMENT", label: "Documents" },
];

export const formatDate = (iso) => (iso ? dayjs(iso).format("DD MMM YYYY") : "");
export const formatDateTime = (iso) => (iso ? dayjs(iso).format("DD MMM YYYY, HH:mm") : "");

export const formatQty = (n) =>
  Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });

export const formatBytes = (bytes) => {
  const b = Number(bytes || 0);
  if (b < 1024) return `${b} B`;
  if (b < 1024 * 1024) return `${(b / 1024).toFixed(0)} KB`;
  return `${(b / (1024 * 1024)).toFixed(1)} MB`;
};

export const mapsUrl = (lat, lng) => `https://www.google.com/maps?q=${lat},${lng}`;
